import { PptxReadOption } from '@/models/PptxReadOption';
import { IdNamePair } from '@/models/ConfigurationOptions';

export class powerPointConfigurationService {

    public static getReadOptions(): Array<IdNamePair> {
        return [
            { id: PptxReadOption.SlidesOnly, name: 'Slides only' },
            { id: PptxReadOption.SlidesAndNotes, name: 'Slides and notes' },
        ]
    }
}
